const tournamentPrizePool = {
  usd: 0,
  // T-Gem of one week's draws (Silver + Gold + Diamond in the backend's
  // prizePool.json) — update together with it
  lottery: 977,
};

const currentLotterySeason = 9;

export { currentLotterySeason, tournamentPrizePool };
